// extracted by mini-css-extract-plugin
export default {"wrapper":"PagerContainer_wrapper__eNMYj","info":"PagerContainer_info__wsPac","button":"PagerContainer_button__0pyRZ","buttondisabled":"PagerContainer_buttondisabled__66fiQ"};